import type { BoardModel } from '../board/BoardModel';
import type { TileStackModel } from '../board/TileStackModel';
import { BoardEventType } from '../board/BoardEvents';
import type { GameTutorialController } from '../../../tutorials/game/GameTutorialController';

export class BoosterMoveModel {
  private tutorial: GameTutorialController | null = null;

  constructor(private readonly board: BoardModel) {}

  public canExecute(): boolean {
    return this.board.hasMoveableStacks();
  }

  public setTutorialController(tutorial: GameTutorialController | null): void {
    this.tutorial = tutorial;
  }

  public canMoveStack(stack: TileStackModel): boolean {
    if (this.tutorial && !this.tutorial.canUseBoosterOnStack(stack)) return false;
    return !stack.isBlocked() && stack.hasTiles();
  }

  private canUseAsMoveTarget(stack: TileStackModel): boolean {
    if (this.tutorial && !this.tutorial.canUseBoosterOnStack(stack)) return false;
    return !stack.isBlocked();
  }

  public canExecuteOnStacks(stack: TileStackModel, secondStack: TileStackModel): boolean {
    if (!this.canMoveStack(stack) || !this.canUseAsMoveTarget(secondStack)) return false;
    return stack !== secondStack;
  }

  public execute(stackA: TileStackModel, stackB: TileStackModel): void {
    if (!this.canExecuteOnStacks(stackA, stackB)) return;
    const stackATiles = stackA.removeAllTiles();
    const stackBTiles = stackB.removeAllTiles();
    stackA.addTiles(stackBTiles);
    stackB.addTiles(stackATiles);

    this.board.events.emit(BoardEventType.StacksSwapped, {
      id: `StacksSwapped_${stackA.id}_${stackB.id}`,
      stackId: stackA.id,
      otherStackId: stackB.id,
    });

    this.board.checkMatchesFromStack(stackB.id);
    this.board.checkMatchesFromStack(stackA.id);
  }
}
